define.alias("shared/utils/formatters/format-hashtag-trends", "settings/utils/formatters/format-hashtag-trends");